<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Modúlo de pagos</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( grupos  , 'CURSOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

	  		    <v-btn
              color="orange"
              dark
              class="mr-2 text-capitalize"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>
          
	  		  <v-card-text>
	  		  	<v-row>
	  		  		<v-col cols="12" lg="5" md="6">
		  		  		<v-radio-group
						      v-model="tipoPago"
						      row
						    >
						      <v-radio
						        label="Colegiaturas"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Paquetes"
						        :value="2"
						      ></v-radio>
						      <v-radio
						        label="Artículos"
						        :value="3"
						      ></v-radio>
						      <v-radio
						        label="Inscripción"
						        :value="4"
						      ></v-radio>
						    </v-radio-group>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="6">
	  		  			<v-autocomplete
				          filled
				          dense
				          clearable
				          v-model="plantel"
				          :items="planteles"
				          label="Plantel"
				          hide-details
				          item-text="plantel"
				          item-value="id_plantel"
				          clearable
				        >
	        			</v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="6">
	  		  			<v-autocomplete
				          filled
				          dense
				          clearable
				          v-model="cursoSeleccionado"
				          :items="cursos"
				          label="Curso"
				          hide-details
				          item-text="curso"
				          item-value="curso"
				          clearable
				        >
	        			</v-autocomplete>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="2" md="6">
	  		  			<v-text-field
	  		  			  label="Fecha Inicio"
	  		  			  filled
	  		  			  dense
	  		  			  type="date"
	  		  			  hide-details
	  		  			  v-model="fecha"
	  		  			></v-text-field>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="2" md="6">
	  		  			<v-text-field
	  		  			  label="Fecha Final"
	  		  			  filled
	  		  			  dense
	  		  			  type="date"
	  		  			  hide-details
	  		  			  v-model="fechaFin"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>


	  		  	<v-row justify="end">

	  		  		<v-col cols="12" lg="6" md="12">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>

	  		  	</v-row>

	  		  	<!-- Diseño del reporte -->
	  		  	<v-row>
	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center green--text" color="#c0f7aa">
	  		  				<div><b>EFECTIVO</b></div>
	  		  				<div class="text-h5"><b>{{ format( montoEfectivo ) }} ( {{ movimientosEfectivo }} )</b></div>
	  		  			</v-card>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center orange--text" color="#f7d48a">
	  		  				<div><b>DEPOSITO</b></div>
	  		  				<div class="text-h5"><b>{{ format( montoDeposito ) }} ( {{ movimientosDeposito }} )</b></div>
	  		  			</v-card>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center red--text" color="#fb949c">
	  		  				<div><b>TARJETA</b></div>
	  		  				<div class="text-h5"><b>{{ format( montoTarjeta ) }} ( {{ movimientosTarjeta }} )</b></div>
	  		  			</v-card>
	  		  		</v-col>

	  		  		<v-col cols="12" lg="3" md="4">
	  		  			<v-card class="shadowCard pa-4 text-center grey--text" color="#eaeaea">
	  		  				<div><b>TODO</b></div>
	  		  				<div class="text-h5"><b>{{ format( montoTotal ) }} ( {{ movimientos }} )</b></div>
	  		  			</v-card>
	  		  		</v-col>
	  		  	</v-row>

	  		    <v-row>
	  		    	<v-col cols="12">

	  		    		<CArticulos
	  		    			:headersGrupos="headersGrupos"
									:filterPagosGruposList="filterPagosGruposList"
									:search="search"
									@deleteItem="deleteItem"
									v-if="tipoPago == 1"
									:tipoPago="tipoPago"
	  		    		/>

	  		    		<CArticulos
	  		    			:headersGrupos="headers2"
									:filterPagosGruposList="filterPagosPaquetesList"
									:search="search"
									@deleteItem="deleteItem"
									v-if="tipoPago == 2"
									:tipoPago="tipoPago"
	  		    		/>

	  		    		<CArticulos
	  		    			:headersGrupos="headers"
									:filterPagosGruposList="filterPagosArticulosList"
									:search="search"
									@deleteItem="deleteItem"
									v-if="tipoPago == 3"
									:tipoPago="tipoPago"
	  		    		/>

	  		    		<CArticulos
	  		    			:headersGrupos="headers"
									:filterPagosGruposList="filterPagosArticulosListInsc"
									:search="search"
									@deleteItem="deleteItem"
									v-if="tipoPago == 4"
									:tipoPago="tipoPago"
	  		    		/>
							  
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="1000px"
      persistent
    >
      <v-card>
      	<v-stepper v-model="pasoPago">
			    <v-stepper-header>
			      <v-stepper-step
			        :complete="pasoPago > 1"
			        step="1"
			      >
			        Selecciona un alumno
			      </v-stepper-step>

			      <v-divider></v-divider>

			      <v-stepper-step
			        :complete="pasoPago > 2"
			        step="2"
			      >
			      	Opción de pago
			      </v-stepper-step>

			      <v-divider></v-divider>

			      <v-stepper-step step="3">
			        Realizar pago
			      </v-stepper-step>
			    </v-stepper-header>

			    <v-stepper-items>
			      <v-stepper-content step="1">
			        <v-card>

			        	<v-card-text>
			        		<v-row>
				          	<v-col cols="12">
				          		<label>Selecciona un alumno para continuar</label>
				          		<v-autocomplete
							          outlined
							          clearable
							          v-model="alumno"
							          :items="alumnos"
							          label="Selecciona un alumno"
							          hide-details
							          item-text="nombre_completo"
							          item-value="idalumnos"
							        >
				        			</v-autocomplete>
				          	</v-col>
				          </v-row>
			        	</v-card-text>

			        	<v-card-actions>
			        		<v-spacer></v-spacer>
					        <v-btn
					          color="primary"
					          @click="pasoPago = 2"
					        >
					          Continuar
					        </v-btn>

					        <v-btn text @click="close( )">
					          Cancelar
					        </v-btn>
			        	</v-card-actions>
			      	</v-card>
			      </v-stepper-content>

			      <v-stepper-content step="2">
			        <v-card>

			        	<v-card-text>
			        		<v-row>
				          	<v-col cols="12">
				          		<label>Selecciona un tipo de compra</label>
				          		<v-radio-group
									      v-model="opPago"
									      row
									    >
									      <v-radio
									        label="Colegiatura"
									        :value="1"
									      ></v-radio>
									      <v-radio
									        label="Paquetes"
									        :value="2"
									      ></v-radio>
									      <v-radio
									        label="Artículos"
									        :value="3"
									      ></v-radio>
									    </v-radio-group>
				          	</v-col>
				          </v-row>
			        	</v-card-text>

			        	<v-card-actions>
			        		<v-spacer></v-spacer>
					        <v-btn text @click="close( )">
					          Cancelar
					        </v-btn>
			        	</v-card-actions>
			      	</v-card>

			      </v-stepper-content>

			      <v-stepper-content step="3">
			        <v-card>
			        	<v-card-text>
				          <v-row>

				          	<v-col cols="12" v-if="opPago == 1">

				          		<v-row v-if="!grupoAnterior" class="black--text">
					          		<v-col cols="12">
						          		<v-autocomplete
									          filled
									          dense
									          clearable
									          v-model="grupo"
									          :items="grupos"
									          label="Selecciona un grupo"
									          hide-details
									          return-object
									          item-text="nombre_grupo"
									          item-value="idgrupos"
									        >
						        			</v-autocomplete>
						          	</v-col>

						          	<v-col cols="12" lg="6" v-if="grupo">
						          		<div><b>Duración:</b> {{ grupo.duracion }} meses</div>
						          		<div><b>Tipo de frecuencia:</b></div>
						          		<v-radio-group
											      v-model="frecuencia_pago"
											      row
											    >
											      <v-radio
											        label="Mensual"
											        :value="1"
											      ></v-radio>
											      <v-radio
											        label="Semanal"
											        :value="2"
											      ></v-radio>
											    </v-radio-group>

						          		<div>

						          			<label>Selecciona una opción</label>
						          			<v-radio-group
												      v-model="opInscripcion"
												      row
												    >
												      <v-radio
												        label="Inscripción"
												        :value="1"
												      ></v-radio>
												      <v-radio
												        label="Sin inscripción"
												        :value="2"
												      ></v-radio>
												    </v-radio-group>

						          			<v-text-field
						          				v-if="opInscripcion == 1"
								          		v-model="pago_inscripcion"
								          		dense
								          		filled
								          		type="number"
								          		label="Pago de inscripción"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="total_pagado_grupo"
								          		dense
								          		filled
								          		type="number"
								          		label="Total a pagar"
								          	>
								          	</v-text-field>

						          			<v-text-field
								          		v-model="pagado"
								          		dense
								          		filled
								          		type="number"
								          		label="Pagado"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="semana"
								          		dense
								          		filled
								          		type="number"
								          		label="semana"
								          		v-if="frecuencia_pago != 1"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="mes"
								          		dense
								          		filled
								          		type="number"
								          		label="Mes"
								          		v-if="frecuencia_pago == 1"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="cambioGrupo"
								          		dense
								          		filled
								          		label="Cambio"
								          		readonly
								          	>
								          	</v-text-field>

								          	<!-- Label -->
								          	<label>Elige la forma de pago</label>
								          	<v-radio-group
												      v-model="forma_pago"
												      column
												    >
												      <v-radio
												      	v-for="(item, i) in tipos_pago"
												      	:key="i"
												        :label="item.tipo"
												        :value="item.id"
												      ></v-radio>
												    </v-radio-group>


												    <v-text-field
								          		v-model="folio"
								          		dense
								          		filled
								          		label="Folio"
								          	>
								          	</v-text-field>

												    <v-btn
									            color="green darken-1"
									            outlined
									            dark
									            @click="save( 3 )"
									          >
									            Realizar pago
									          </v-btn>
						          		</div>
						          	</v-col>
				          		</v-row>

				          		<v-row v-else class="black--text">
						          	<v-col cols="12" lg="6" v-if="grupoAnterior.grupo">
						          		<div><b>Duración:</b> {{ grupoAnterior.grupo.duracion }} meses</div>
						          		<div><b>Tipo de frecuencia:</b> {{ grupoAnterior.frecuencia_pago == 1 ? 'Mensual' : 'Semanal' }}</div>
						          		<div :class="grupoAnterior.adeudo > 0 ? 'red--text' : 'white--text' "><b>Adeudo:</b> {{ grupoAnterior.adeudo > 0 ? format( grupoAnterior.adeudo ) : 0 }}</div>
						          		<div v-if="grupoAnterior.mesesAdeudos">Meses de adeudo: {{ grupoAnterior.mesesAdeudos }}</div>
						          		<br/>
						          		<div>
								          	<v-text-field
								          		v-if="grupoAnterior.mesesAdeudos"
								          		v-model="multa"
								          		dense
								          		filled
								          		type="number"
								          		label="Multa"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="totalPagarColegiatura"
								          		dense
								          		readonly
								          		filled
								          		type="number"
								          		label="Total a pagar"
								          	>
								          	</v-text-field>

								          	<label>Selecciona una opción</label>
						          			<v-radio-group
												      v-model="opInscripcion"
												      row
												    >
												      <v-radio
												        label="Inscripción"
												        :value="1"
												      ></v-radio>
												      <v-radio
												        label="Sin inscripción"
												        :value="2"
												      ></v-radio>
												    </v-radio-group>

												    <v-text-field
						          				v-if="opInscripcion == 1"
								          		v-model="pago_inscripcion"
								          		dense
								          		filled
								          		type="number"
								          		label="Pago de inscripción"
								          	>
								          	</v-text-field>

						          			<v-text-field
								          		v-model="pagado"
								          		dense
								          		filled
								          		type="number"
								          		label="Pagado"
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="semana"
								          		dense
								          		filled
								          		type="number"
								          		label="Semana"
								          		v-if=" grupoAnterior.frecuencia_pago != 1 "
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="mes"
								          		dense
								          		filled
								          		type="number"
								          		label="Mes"
								          		v-if=" grupoAnterior.frecuencia_pago == 1 "
								          	>
								          	</v-text-field>

								          	<v-text-field
								          		v-model="cambioGrupoPagoAnterior"
								          		dense
								          		filled
								          		label="Cambio"
								          		readonly
								          	>
								          	</v-text-field>

								          	<!-- Label -->
								          	<label>Elige la forma de pago</label>
								          	<v-radio-group
												      v-model="forma_pago"
												      column
												    >
												      <v-radio
												      	v-for="(item, i) in tipos_pago"
												      	:key="i"
												        :label="item.tipo"
												        :value="item.id"
												      ></v-radio>
												    </v-radio-group>

												    <div v-if="adeudoColegiatura > 0 " class="red--text">Adeudo: {{ adeudoColegiatura }}</div>

												    <v-text-field
								          		v-model="folio"
								          		dense
								          		filled
								          		label="Folio"
								          	>
								          	</v-text-field>

												    <v-btn
									            color="green darken-1"
									            outlined
									            dark
									            @click="realizarInscripcion2( 3 )"
									          >
									            Realizar pago
									          </v-btn>
						          		</div>
						          	</v-col>
				          		</v-row>
				          	</v-col>

				          	<!-- PAGOS DE PAQUETES -->
				          	<v-col cols="12" v-if="opPago == 2">
				          		<v-row>

				          			<v-col cols="12">
						          		<v-card class="shadowCard">
						          			<v-card-text>
							          			<v-row>

							          				<v-col cols="12" v-if="tieneAdeudoPaquete">
							          					<v-alert
															      dense
															      outlined
															      type="error"
															    >
															      El alumno cuenta con un adeudo, ingresa el adeudo para continuar
															    </v-alert>	
							          				</v-col>

								          			<v-col cols="12" lg="8" v-if="!tieneAdeudoPaquete">
										          		<v-autocomplete
													          filled
													          dense
													          clearable
													          v-model="paquete"
													          :items="paquetes"
													          label="Selecciona un paquete"
													          hide-details
													          return-object
													          item-text="nombre"
													          item-value="idpaquetes"
													        >
													        </v-autocomplete>
								          			</v-col>

								          			<v-col cols="12" lg="2" v-if="!tieneAdeudoPaquete">
									          			<v-text-field
											          		v-model="cantidad"
											          		dense
											          		hide-details
											          		filled
											          		type="number"
											          		label="Cantidad"
											          	>
											          	</v-text-field>
											          </v-col>

											          <v-col cols="12" lg="2" v-if="!tieneAdeudoPaquete">
									          			<v-btn
									          				@click="addPaquetes( )"
									          				color="primary"
									          			>
									          				<v-icon>mdi-plus</v-icon>
									          			</v-btn>
											          </v-col>

											          <v-col cols="12">
											          	<v-data-table
									                  :headers="headersPasquetes"
									                  :items="comprarPaquetes"
									                  class="elevation-0"
									                  :mobile-breakpoint="100"
									                  hide-details
									                  hide-default-footer
									                  dense
									                >
									                  <template v-slot:item.foto="{ item }">
									                    <v-img :src="url + item.foto" aspect-ratio="2" contain/>
									                  </template>

									                  <template v-slot:item.actions="{ item }">
									                    <v-btn
									                      color="error"
									                      x-small
									                      @click="deleteItem(item)"
									                      class="mr-2"
									                      icon
									                    >
									                      <v-icon small>mdi-delete</v-icon>
									                    </v-btn>
									                  </template>
									                </v-data-table>
											          </v-col>
							          			</v-row>
						          			</v-card-text>
						          		</v-card>
				          			</v-col>


							          <v-col cols="12" lg="4" md="6">
							          	<!-- Solo mostrar si tiene un pago anterior -->
							          	<div class="text-h6" v-if="pagoAnterior > 0">Pago Anterior: {{ pagoAnterior }}</div>
							          	<div class="text-h6">Total a pagar: {{ pagoPaquete }}</div>

							          	<!-- Label -->
							          	<label>Elige la forma de pago</label>
							          	<v-radio-group
											      v-model="forma_pago"
											      column
											    >
											      <v-radio
											      	v-for="(item, i) in tipos_pago"
											      	:key="i"
											        :label="item.tipo"
											        :value="item.id"
											      ></v-radio>
											    </v-radio-group>

							          	<v-text-field
							          		v-model="pagado"
							          		dense
							          		filled
							          		type="number"
							          		label="Pagado"
							          	>
							          	</v-text-field>

							          	<div class="text-h6">Cambio: {{ cambio }}</div>
							          	<div class="text-h6 red--text">Adeudo: {{ adeudoPaquete }}</div>

							          	<v-text-field
							          		v-model="folio"
							          		dense
							          		filled
							          		label="Folio"
							          	>
							          	</v-text-field>

											    <v-btn
								            color="green darken-1"
								            outlined
								            dark
								            @click="save( 1 )"
								          >
								            Realizar pago
								          </v-btn>
							          </v-col>

							          <v-col cols="12" lg="8" md="6">
							          	<label>Agregar comprobante de pago</label>
							          	<v-col cols="12" md="6" v-if="forma_pago && forma_pago != 1">
									        <v-card-text align="center" class="pa-0">
									          <div v-if="!file">
									            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
									              <div class="dropZone-info" @drag="onChange">
									                <span class="fa fa-cloud-upload dropZone-title"></span>
									                <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
									                <div class="dropZone-upload-limit-info">
									                  <div>Extensión: png, jpg, jpeg, svg</div>
									                  <div>Tamaño máximo: 10 MB</div>
									                </div>
									              </div>
									              <input type="file" @change="onChange">
									            </div>
									          </div>

									          <v-btn  v-else color="red" class="mb-2" dense @click="removeFile" fab small dark><v-icon>mdi-delete</v-icon></v-btn>
									          <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
									        </v-card-text>

												</v-col>
							          </v-col>
				          		</v-row>
				          	</v-col>

				          	<!-- PAGOS DE ARTICULOS -->
				          	<v-col cols="12" v-if="opPago == 3">
				          		<v-row>
				          			<v-col cols="12" lg="8">
						          		<v-autocomplete
									          filled
									          dense
									          clearable
									          v-model="articulo"
									          :items="articulos"
									          label="Selecciona un artículo"
									          hide-details
									          return-object
									          item-text="articulo"
									          item-value="idarticulos"
									        >
									        </v-autocomplete>
				          			</v-col>

				          			<v-col cols="12" lg="2">
					          			<v-text-field
							          		v-model="cantidad"
							          		dense
							          		hide-details
							          		filled
							          		type="number"
							          		label="Cantidad"
							          	>
							          	</v-text-field>
							          </v-col>

							          <v-col cols="12" lg="2">
					          			<v-btn
					          				@click="addArticulos( )"
					          				color="primary"
					          			>
					          				<v-icon>mdi-plus</v-icon>
					          			</v-btn>
							          </v-col>

							          <v-col cols="12">
							          	<v-data-table
					                  :headers="headersArticulos"
					                  :items="comprarArticulos"
					                  class="elevation-0"
					                  :mobile-breakpoint="100"
					                  dense
					                >
					                  <template v-slot:item.foto="{ item }">
					                    <v-img :src="url + item.foto" aspect-ratio="2" contain/>
					                  </template>

					                  <template v-slot:item.actions="{ item }">
					                    <v-btn
					                      color="error"
					                      x-small
					                      @click="deleteItem(item)"
					                      class="mr-2"
					                      icon
					                    >
					                      <v-icon small>mdi-delete</v-icon>
					                    </v-btn>
					                  </template>
					                </v-data-table>
							          </v-col>

							          <v-col cols="12" lg="4" md="6">
							          	<div class="text-h6">Total a pagar: {{ pagoArticulo }}</div>
							          	<v-text-field
							          		v-model="pagado"
							          		dense
							          		filled
							          		type="number"
							          		label="Pagado"
							          	>
							          	</v-text-field>

							          	<v-text-field
							          		v-model="cambioArticulo"
							          		dense
							          		filled
							          		label="Cambio"
							          		readonly
							          	>
							          	</v-text-field>

							          	<!-- Label -->
							          	<label>Elige la forma de pago</label>
							          	<v-radio-group
											      v-model="forma_pago"
											      column
											    >
											      <v-radio
											      	v-for="(item, i) in tipos_pago"
											      	:key="i"
											        :label="item.tipo"
											        :value="item.id"
											      ></v-radio>
											    </v-radio-group>

											    <v-text-field
							          		v-model="folio"
							          		dense
							          		filled
							          		label="Folio"
							          	>
							          	</v-text-field>

											    <v-btn
								            color="green darken-1"
								            outlined
								            dark
								            @click="save( 2 )"
								          >
								            Realizar pago
								          </v-btn>
							          </v-col>

							          <v-col cols="12" lg="8" md="6">
							          	<label>Agregar comprobante de pago</label>
							          	<v-col cols="12" md="6" v-if="forma_pago && forma_pago != 1">
									        <v-card-text align="center" class="pa-0">
									          <div v-if="!file">
									            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
									              <div class="dropZone-info" @drag="onChange">
									                <span class="fa fa-cloud-upload dropZone-title"></span>
									                <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
									                <div class="dropZone-upload-limit-info">
									                  <div>Extensión: png, jpg, jpeg, svg</div>
									                  <div>Tamaño máximo: 10 MB</div>
									                </div>
									              </div>
									              <input type="file" @change="onChange">
									            </div>
									          </div>

									          <v-btn  v-else color="red" class="mb-2" dense @click="removeFile" fab small dark><v-icon>mdi-delete</v-icon></v-btn>
									          <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
									        </v-card-text>

												</v-col>
							          </v-col>
				          		</v-row>
				          	</v-col>
				          </v-row>
			        	</v-card-text>
			      	</v-card>
			        <v-btn text @click="close( )">
			          Cancel
			        </v-btn>
			      </v-stepper-content>
			    </v-stepper-items>
			  </v-stepper>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el pago?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>

	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import CArticulos            from '@/components/inscripciones/articulos.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import funcionesBasicasPagos from '@/mixins/funcionesBasicasPagos'


  export default {

    mixins: [ validarErrores, funcionesExcel, funcionesBasicasPagos ],

  	components:{
      Alerta,
      carga,
      CArticulos
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      tipoPago: 1,

      // fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fecha: "2025-07-01",
      fechaFin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),


      opPago: null,
      paquete: null,
			paquetes: [],
			cantidad:1,
			comprarPaquetes : [],
			comprarArticulos: [],

      url: '',
      tipo_pago: null,
			tipos_pago:[
      	{ id: 1, tipo: 'EFECTIVO'},
      	{ id: 2, tipo: 'DEPOSITO / TRANSFERENCIA'},
      	{ id: 4, tipo: 'TARJETA' },
      ],

      dragging: false,
      vistaPrevia: [],
      archivos:null,

      file: null,


      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      cursos: [],

      headers: [
        { text: 'Alumno'        , value: 'alumno'         },
        { text: 'Tipo de pago'  , value: 'forma_pago'     },
        { text: 'Detalles'      , value: 'detalles'       },
        { text: 'Plantel'       , value: 'plantel'        },
        { text: 'Pagado'        , value: 'pagado'         },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Folio'         , value: 'folio'          },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headers2: [
        { text: 'Alumno'        , value: 'alumno'         },
        { text: 'Tipo de pago'  , value: 'forma_pago'     },
        { text: 'Plantel'       , value: 'plantel'        },
        { text: 'Pagado'        , value: 'pagado'         },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Folio'         , value: 'folio'          },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headersGrupos:[
      	{ text: 'Alumno'        , value: 'alumno'        },
      	{ text: 'Curso'         , value: 'curso'         },
      	{ text: 'Semana'        , value: 'semana'        },
      	{ text: 'Mes'           , value: 'mes'        },
      	{ text: 'Horario'       , value: 'horario'       },
        { text: 'Tipo de pago'  , value: 'forma_pago'    },
        { text: 'Plantel'       , value: 'plantel'       },
        { text: 'Pagado'        , value: 'pagado'        },
        { text: 'Fecha Alta'    , value: 'fecha_creacion' },
        { text: 'Folio'         , value: 'folio' },
        { text: 'Folio2'        , value: 'folio2' },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],

      headersAlumnos: [
        { text: 'ID'       , value: 'idgruposalumnos'  },
        { text: 'Alumno'   , value: 'alumno'           },
        { text: 'Teléfono' , value: 'telefono'         },
        { text: 'Edad'     , value: 'edad'             },
        { text: 'Correo'   , value: 'correo'           },
        { text: 'Actions'  , value: 'actions', sortable: false },
      ],

      headersPasquetes: [
        { text: 'ID'       , value: 'idpaquetes' },
        { text: 'Nombre'   , value: 'nombre' },
        { text: 'Costo'    , value: 'costo' },
        { text: 'Cantidad' , value: 'cantidad' },
        { text: 'Costo T.' , value: 'costo_total' },
        { text: 'Foto'     , value: 'foto' },
        { text: 'Folio2'   , value: 'folio3' },
        { text: 'Acciones' , value: 'actions', sortable: false },
      ],

      headersArticulos: [
        { text: 'ID'       , value: 'idarticulos' },
        { text: 'Nombre'   , value: 'articulo'    },
        { text: 'Detalles' , value: 'detalles'    },
        { text: 'Costo'    , value: 'precio'      },
        { text: 'Cantidad' , value: 'cantidad'    },
        { text: 'Costo T.' , value: 'costo_total' },
        { text: 'Foto'     , value: 'foto' },
        { text: 'Folio2'   , value: 'folio4' },
        { text: 'Acciones' , value: 'actions', sortable: false },
      ],

			cursoSeleccionado: null,
    	
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      dialogDeleteAlumno: false,
      pagado: 0,

      forma_pago: null,
      articulo: null,
			articulos:[],
			pagosPaquetesList:[],
			pagosArticulosList:[],
			grupoAnterior: null,
			grupos:[],
			grupo: null,
			frecuencia_pago: null,
			pago_inscripcion: 0,
			total_pagado_grupo:0,
			pagosGruposList:[],

			folio:'',

			plantel: null,

			semana: 0,
			mes: 0,

			pasoPago: 1,
			multa: 0,
			opInscripcion: null,
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
      	val || this.closeAlumnos( )
      },

			opPago( value ){

      	if( value  == 1 && this.alumno ){ this.consultarExistenciaAlumno( ) }
      	if( value  == 2 && this.alumno ){ this.validarAdeudoPaquete( ) }
      	if( value  == 3 ){ this.pasoPago = 3 }

			},

    },

    async created () {
      this.url = this.$http.options.root + 'articulos-enlace/';

      console.log( this.getdatosUsuario )

      await this.initialize()
      await this.getPaquetes()
      await this.getArticulos()
      await this.getAlumnos()
      await this.getGrupos()
      await this.getPlanteles( )
      await this.getCursos( )
    },

    methods: {
      initialize () {
      	this.pagosPaquetes( )
      	this.pagosArticulos( )
      	this.pagosGrupos( )
      },

      getCursos () {
      	this.cargar = true
        this.cursos = []
        return this.$http.get('cursos.list').then(response=>{
        	this.cursos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      pagosPaquetes () {
      	this.cargar = true
        this.pagosPaquetesList = []
        const payload = {
        	fecha: this.fecha,
        	fechaFin: this.fechaFin
        }

        return this.$http.post('compras.paquetes', payload).then(response=>{
        	// this.pagosPaquetesList = response.data
        	this.pagosPaquetesList = response.data.filter( el => el.idplantel == this.getdatosUsuario.idplanteles )
        	
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      pagosArticulos () {
      	this.cargar = true
        this.pagosArticulosList = []
        const payload = {
        	fecha: this.fecha,
        	fechaFin: this.fechaFin
        }

        return this.$http.post('compras.articulos', payload ).then(response=>{
        	// this.pagosArticulosList = response.data
        	this.pagosArticulosList = response.data.filter( el => el.idplantel == this.getdatosUsuario.idplanteles )
        	
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      pagosGrupos () {
      	this.cargar = true
        this.pagosGruposList = []
        const payload = {
					fecha: this.fecha,
        	fechaFin: this.fechaFin
        }

        return this.$http.post('compras.grupos', payload).then(response=>{
        	// this.pagosGruposList = response.data
        	this.pagosGruposList = response.data.filter( el => el.idplantel == this.getdatosUsuario.idplanteles )
        	
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItem(item) {
	      this.editedIndex = this.alumnos.indexOf(item);
	      this.editedItem = Object.assign({}, item);
	      console.log( this.editedItem )
	      this.dialogDelete = true;
	    },


      getPaquetes () {
      	this.cargar = true
        this.paquetes = []
        return this.$http.get('paquetes.list').then(response=>{
        	this.paquetes = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getArticulos () {
      	this.cargar = true
        this.articulos = []
        return this.$http.get('articulos.list').then(response=>{
        	this.articulos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getGrupos ( ) {
      	this.cargar = true
        this.grupos = []
        return this.$http.get('grupos.activos').then(response=>{
        	this.grupos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      addPaquetes( ){

      	// Validar que haya un paquete seleccionado
      	if( this.paquete ){

      		this.comprarPaquetes.push({
      			idpaquetes: this.paquete.idpaquetes,
      			nombre:     this.paquete.nombre,
      			foto:       this.paquete.foto,
      			cantidad:   this.cantidad,
      			costo:      this.paquete.precio,
      			costo_total: ( this.paquete.precio * this.cantidad)
      		})

      		this.paquete  = null
      		this.cantidad = 1

      	}
      },

      addArticulos( ){

      	// Validar que haya un paquete seleccionado
      	if( this.articulo ){

      		this.comprarArticulos.push({
      			idarticulos: this.articulo.idarticulos,
      			articulo:    this.articulo.articulo,
      			foto:        this.articulo.foto,
      			cantidad:    this.cantidad,
      			precio:      this.articulo.precio,
      			costo_total: ( this.articulo.precio * this.cantidad)
      		})

      		this.articulo  = null
      		this.cantidad = 1

      	}
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
      	this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
        	this.horarios = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
      	this.cargar = true
        this.usuarios = []
        return this.$http.get('users').then(response=>{
        	this.usuarios = response.data
        	this.teachers = response.data.filter( el => el.idpuestos == 27 )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getAlumnos () {
      	this.cargar = true
        this.alumnos = []
        return this.$http.get('alumnos.list').then(response=>{
        	this.alumnos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })

        this.pasoPago = 1
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save ( op ) {
	      this.cargar = true

	      if( op == 1 ){

	      	// Iniciamos las validaciones
	      	if( this.pagado <= 0 ){ return this.validarErrorDirecto('Favor de ingresar un pago') }
	      	if( !this.comprarPaquetes.length > 0){ return this.validarErrorDirecto('Favor de seleccionar un paquete') }

	      	this.compraPaquete( )
	      }

	      if( op == 2 ){
	      	this.compraArticulo( )
	      }

	      if( op == 3 ){
	      	this.realizarInscripcion( )
	      }
      },

      deleteItemConfirm() {
	      // Lo mandapos por el EP
	      this.editedItem.deleted = 1;
	      this.$http.put("pagos.update/" + this.editedItem.idpagos_grupos_detalles, this.editedItem ).then((response) => {
          this.dialogSuccess = true;
          this.cargar = false;
          this.closeDelete();
          this.initialize();
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
	    },

      compraPaquete( ){

      	// Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"         , this.files                          );
        formData.append("idalumnos"    , this.alumno                         );
        formData.append("pagado"       , this.pagado                         );
        formData.append("forma_pago"   , this.forma_pago                     );
        formData.append("usuario_creo" , this.getdatosUsuario.id             );
        formData.append("idplantel"    , this.getdatosUsuario.idplanteles    );
        formData.append("paquetes"     , JSON.stringify(this.comprarPaquetes));
        formData.append("adeudo"       , this.adeudoPaquete );
        formData.append("costo"        , this.pagoPaquete );
        formData.append("folio"        , this.folio );
        formData.append("adeudoAnt"    , this.tieneAdeudoPaquete );
        formData.append("info"         , this.infoPaqueteAdeudo ? this.infoPaqueteAdeudo.idpagos_paquetes : 0 );

      	// Lo mandapos por el EP
        this.$http.post('comprar.paquete', formData ).then(response=>{

        	this.files = null
					this.alumno = null
					this.pagado = 0
					this.forma_pago = null
					this.comprarPaquetes = []
					this.grupoAnterior = null
					this.opPago = null
					this.pasoPago = 1
					this.close( )
        	this.initialize( )
        	this.cargar = false
					this.folio = ''

        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      compraArticulo( ){

      	// Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"         , this.files                          );
        formData.append("idalumnos"    , this.alumno                         );
        formData.append("pagado"       , this.pagado                         );
        formData.append("forma_pago"   , this.forma_pago                     );
        formData.append("usuario_creo" , this.getdatosUsuario.id             );
        formData.append("folio"        , this.folio );
        formData.append("idplantel"    , this.getdatosUsuario.idplanteles    );
        formData.append("articulos"    , JSON.stringify(this.comprarArticulos));

      	// Lo mandapos por el EP
        this.$http.post('comprar.articulos', formData ).then(response=>{

        	this.files = null
					this.alumno = null
					this.pagado = 0
					this.forma_pago = null
					this.comprarArticulos = []
					this.grupoAnterior = null
					this.opPago = null
					this.close( )
        	this.initialize( )
					this.folio = ''
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      realizarInscripcion( ){

      	// Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"            , this.files                          );
        formData.append("idalumnos"       , this.alumno                         );
        formData.append("idgrupos"        , this.grupo.idgrupos                 );
        formData.append("inscripcion"     , this.pago_inscripcion               );
        formData.append("usuario_creo"    , this.getdatosUsuario.id             );
        formData.append("frecuencia_pago" , this.frecuencia_pago                );
        formData.append("pago_recurrente" , this.total_pagado_grupo             );
        formData.append("idsucursales"    , this.getdatosUsuario.idplanteles    );
        formData.append("pagado"          , parseFloat( this.pagado ) - parseFloat( this.adeudoColegiatura ) );
        formData.append("forma_pago"      , this.forma_pago                     );
        formData.append("semana"          , this.semana                         );
        formData.append("mes"             , this.mes                            );
        formData.append("folio"           , this.folio );
        formData.append("adeudo"          , parseFloat( this.adeudoColegiatura ) );

      	// Lo mandapos por el EP
        this.$http.post('comprar.grupos', formData ).then(response=>{

        	this.files = null
					this.alumno = null
					this.pagado = 0
					this.forma_pago = null
					this.grupo = null
					this.pago_inscripcion = 0
					this.frecuencia_pago = null
					this.total_pagado_grupo= 0
					this.grupoAnterior = null
					this.opPago = null
					this.folio = ''


					this.comprarArticulos = []
					this.close( )
        	this.initialize( )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })

      },

      realizarInscripcion2( ){

      	// Creamos el documento
        let formData = new FormData();
        // agregamos el documento
        formData.append("file"            , this.files                          );
        formData.append("idalumnos"       , this.alumno                         );
        formData.append("idgruposalumnos" , this.grupoAnterior.idgruposalumnos  );
        formData.append("inscripcion"     , this.pago_inscripcion               );
        formData.append("usuario_creo"    , this.getdatosUsuario.id             );
        formData.append("frecuencia_pago" , this.grupoAnterior.frecuencia_pago  );
        formData.append("pago_recurrente" , this.grupoAnterior.pago_recurrente  );
        formData.append("idsucursales"    , this.getdatosUsuario.idplanteles    );
        formData.append("forma_pago"      , this.forma_pago                     );
        formData.append("pagado"          , parseFloat( this.pagado - this.cambioGrupoPagoAnterior ) - parseFloat( this.adeudoColegiatura ) );
        formData.append("mes"             , this.mes );
        formData.append("semana"          , this.semana );
        formData.append("folio"           , this.folio );
        formData.append("adeudo"          , parseFloat( this.adeudoColegiatura ) );
        
      	// Lo mandapos por el EP
        this.$http.post('comprar.grupos.detalle', formData ).then(response=>{

        	this.files = null
					this.alumno = null
					this.pagado = 0
					this.forma_pago = null
					this.grupo = null
					this.pago_inscripcion = 0
					this.frecuencia_pago = null
					this.total_pagado_grupo= 0
					this.grupoAnterior = null
					this.semana = 0
					this.mes = 0
					this.opPago = null
					this.multa = 0
					this.folio = ''

					this.comprarArticulos = []
					this.close( )
        	this.initialize( )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })

      },


      consultarExistenciaAlumno( ){

      	const payload = {
      		idalumnos: this.alumno,
      	}

      	// Lo mandapos por el EP
        this.$http.post('alumno.inscrito', payload ).then(response=>{

        	this.grupoAnterior = response.data
        	this.pasoPago = 3

        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })

      },

      onChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      
	      if (!files.length) {
	        this.dragging = false;
	        return;
	      }
	      
	      this.createFile(files[0]);
	    },

	    createFile(file) {
	      if (!file.type.match('image.*')) {
	        alert('please select txt file');
	        this.dragging = false;
	        return;
	      }
	      
	      if (file.size > 10000000) {
	        alert('please check file size no over 5 MB.')
	        this.dragging = false;
	        return;
	      }
	      
	      this.file = file;
	      this.archivos = file;
	      this.getBase64(this.archivos)
	      this.dragging = false;
	    },

	    removeFile() {
	      this.total_pagado = 0
	      this.vistaPrevia        = null
	      this.archivos           = null
	      this.file               = '';
	      this.banco              = ''
	      this.isSpin             = false
	    },

	    getBase64(file) {
	      var me = this
	      var reader = new FileReader();
	      reader.readAsDataURL(file);
	      reader.onload = function () {
	        me.vistaPrevia = {
	          url: reader.result, 
	          image_name: file.name
	        }
	      };
	    },

	    format( valor ){
	      return valor.toLocaleString('es-MX', {
	        style: 'currency',
	        currency: 'MXN'
	      });
	    },
    },
  }
</script>


<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>

<!-- 1674 -->